import { inject } from '@angular/core';
import { HttpContextToken } from '@angular/common/http';
import { CoreProvider } from '../core.provider';
import { filter, firstValueFrom } from 'rxjs';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export const CUSTOM_REQUEST_AUTHORIZATION = new HttpContextToken<string>(() => '');

export const requireGameTrackerGame = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  preventRedirect: boolean = false,
) => {
  const core = inject(CoreProvider);
  const canActivate = core.gameTrackerService.gameDtoStore ? true : false;
  if (!canActivate && !preventRedirect) {
    core.router.navigate(['/game-tracker/past-games']);
  }
  return canActivate;
};

export const requireLoggedIn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  preventRedirect: boolean = false,
) => {
  const core = inject(CoreProvider);
  if (!core.appIsReady$.value) {
    await firstValueFrom(core.appIsReady$.pipe(filter(v => v === true)));
  }
  const canActivate = core.auth.isAuthenticated ? true : false;
  if (!canActivate && !preventRedirect) {
    core.router.navigate(['/login']);
  }
  // console.log('requireLoggedIn', route, state, canActivate, core.appIsReady$.value);
  return canActivate;
};

export const requireSuperadmin = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  preventRedirect: boolean = false,
) => {
  const core = inject(CoreProvider);
  const loggedIn = await requireLoggedIn(route, state, true);
  const canActivate = loggedIn && core.auth.isSuperadmin;
  if (!canActivate && !preventRedirect) {
    core.router.navigate(['/']);
  }
  return canActivate;
};

export const requireLogout: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  preventRedirect: boolean = false,
) => {
  const core = inject(CoreProvider);
  const canActivate = !await requireLoggedIn(route, state, true);
  if (!canActivate && !preventRedirect) {
    core.router.navigate(['/']);
  }
  // console.log('requireLogout', route, state, canActivate);
  return canActivate;
};
